import { createAction, props } from '@ngrx/store';
import { Book } from '@cna/projects/ak-jura/shared/interfaces';
import type { Id, UUID } from '@cna/shared/generic-types';

export const insertBulkExaminablesFailure = createAction(
    '[global] insertBulk examinables failure'
);

// Get Examinables By ModuleId
export const getExaminablesByModuleId = createAction(
    '[global] get examinables by moduleId',
    props<{ moduleId: Id | UUID }>()
);

export const getExaminablesByModuleIdFailure = createAction(
    '[global] get examinables by moduleId failure'
);

// get Book
export const getBookById = createAction(
    '[global] get book by Id',
    props<{ bookId: UUID }>()
);

export const getBookByIdSuccess = createAction(
    '[global] get book by Id success',
    props<{ book: Book }>()
);
export const getBookByIdFailure = createAction(
    '[global] get book by Id failure',
    props<{ error: any }>()
);

export const setNoticeAlreadyBooked = createAction(
    '[global] set already booked Notice',
    props<{ value: boolean }>()
);

export const addOpenedLegalAreaAccordionId = createAction(
    '[global] add opened legalArea accordion Id',
    props<{ accordionId: number }>()
);

export const removeOpenedLegalAreaAccordionId = createAction(
    '[global] remove opened legalArea accordion Id',
    props<{ accordionId: number }>()
);
export const resetOpenedLegalAreaAccordionId = createAction(
    '[global] reset opened legalArea accordion Id'
);
